import { GlobalStyles } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getResponsiveStyles } from "./responsiveStyles";

/**
 * Injects responsive styles via MUI GlobalStyles.
 * All breakpoints from theme.breakpoints (muiTheme.js) - MUI built-in.
 */
const ResponsiveGlobalStyles = () => {
  const theme = useTheme();
  const styles = getResponsiveStyles(theme);
  return <GlobalStyles styles={styles} />;
};

export default ResponsiveGlobalStyles;
